
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import { DataAggregatorTest } from "@/components/payment/DataAggregatorTest";
import { BillStatusUpdate } from "@/components/payment/BillStatusUpdate";
import { SubscriptionStatusCheck } from "@/components/payment/SubscriptionStatusCheck";
import { RenewalSystemTest } from "@/components/payment/RenewalSystemTest";
import { PaymentIntegrationTest } from "@/components/payment/PaymentIntegrationTest";
import { BillComponentDebugger } from "@/components/payment/BillComponentDebugger";
import { ApiTestingTips } from "@/components/payment/components/ApiTestingTips";
import { InfradigitalDirectTest } from "@/components/payment/InfradigitalDirectTest";
import { Alert, AlertDescription, AlertTitle } from "@/components/ui/alert";
import { Terminal } from "lucide-react";

export default function Payment() {
  return (
    <div className="flex-1 space-y-4 p-8 pt-6">
      <div className="flex items-center justify-between space-y-2">
        <h2 className="text-3xl font-bold tracking-tight">Payment Integration Testing</h2>
      </div>
      
      <Alert>
        <Terminal className="h-4 w-4" />
        <AlertTitle>Important Update</AlertTitle>
        <AlertDescription>
          The payment system has been updated to use the original Infradigital function with complete headers.
          The test interface below shows that the original function works while the newer one has issues.
        </AlertDescription>
      </Alert>
      
      <Tabs defaultValue="bill" className="space-y-4">
        <TabsList>
          <TabsTrigger value="bill">Bill Management</TabsTrigger>
          <TabsTrigger value="subscription">Subscription Management</TabsTrigger>
          <TabsTrigger value="renewal">Renewal System</TabsTrigger>
          <TabsTrigger value="aggregator">Data Aggregator</TabsTrigger>
        </TabsList>
        
        <TabsContent value="bill" className="space-y-4">
          <Card>
            <CardHeader>
              <CardTitle>Bill Management</CardTitle>
              <CardDescription>
                Test the functionality related to bill creation and management.
              </CardDescription>
            </CardHeader>
            <CardContent className="space-y-6">
              <InfradigitalDirectTest />
              <BillComponentDebugger />
              <PaymentIntegrationTest />
              <BillStatusUpdate />
            </CardContent>
          </Card>
          <ApiTestingTips />
        </TabsContent>
        
        <TabsContent value="subscription" className="space-y-4">
          <Card>
            <CardHeader>
              <CardTitle>Subscription Management</CardTitle>
              <CardDescription>
                Test the functionality related to subscription status checking.
              </CardDescription>
            </CardHeader>
            <CardContent>
              <SubscriptionStatusCheck />
            </CardContent>
          </Card>
          <ApiTestingTips />
        </TabsContent>
        
        <TabsContent value="renewal" className="space-y-4">
          <Card>
            <CardHeader>
              <CardTitle>Renewal System</CardTitle>
              <CardDescription>
                Test the functionality related to subscription renewal.
              </CardDescription>
            </CardHeader>
            <CardContent>
              <RenewalSystemTest />
            </CardContent>
          </Card>
          <ApiTestingTips />
        </TabsContent>
        
        <TabsContent value="aggregator" className="space-y-4">
          <Card>
            <CardHeader>
              <CardTitle>Data Aggregator</CardTitle>
              <CardDescription>
                Test the data aggregation system.
              </CardDescription>
            </CardHeader>
            <CardContent>
              <DataAggregatorTest />
            </CardContent>
          </Card>
          <ApiTestingTips />
        </TabsContent>
      </Tabs>
    </div>
  );
}
